export default "__VITE_ASSET__ee4c3ac5__$_?nuxt_component=async__"